import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatDividerModule, MatListModule } from '@angular/material';

import { GLinkDemoContentComponent } from './demo-content/demo-content.component';
import { GLinkDemoSidebarComponent } from './demo-sidebar/demo-sidebar.component';

@NgModule({
    declarations: [
        GLinkDemoContentComponent,
        GLinkDemoSidebarComponent
    ],
    imports     : [
        RouterModule,

        MatDividerModule,
        MatListModule
    ],
    exports     : [
        GLinkDemoContentComponent,
        GLinkDemoSidebarComponent
    ]
})
export class GLinkDemoModule
{
}
